import { takeEvery } from 'redux-saga/effects'
import { adminOrganizationUsersResendProtracks } from '../actions'
// @ts-ignore
import { showSuccess } from 'store/entities/toastr/utils'

export default function* handleResendProtrackRequest() {
  yield takeEvery(adminOrganizationUsersResendProtracks.success.toString(), handler)
}

function handler() {
  showSuccess({ content: 'Select ProTrack email sent successfully.' })
}
